export const COORD_COLORS = [
  { soft: '#EEF2FF', strong: '#4F46E5' },
  { soft: '#E0F2FE', strong: '#0284C7' },
  { soft: '#D1FAE5', strong: '#059669' },
  { soft: '#FFEDD5', strong: '#EA580C' },
];

export function getInitials(name) {
  const parts = String(name || '').trim().split(/\s+/);
  return (
    ((parts[0] && parts[0][0]) || '') + ((parts[1] && parts[1][0]) || '')
  ).toUpperCase();
}

export function buildAbbrFromName(name) {
  return (
    String(name || '')
      .replace(/[^A-Za-zÀ-ÿ0-9]/g, '')
      .slice(0, 4)
      .toUpperCase() || 'AREA'
  );
}

export function getCoordColor(index) {
  return COORD_COLORS[index % COORD_COLORS.length];
}
